import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { tryGetTelegram } from '../telegram';

/**
 * Mostra o BackButton nativo do Telegram enquanto a tela está montada e
 * roteia o tap pra `onBack` (default: `navigate(-1)`). Esconde no unmount.
 *
 * Toda rota diferente de `/` no Mini App deve usar este hook — é a forma
 * oficial do Telegram dar feedback de "voltar"; sem ele o usuário fica preso
 * no Mini App e precisa fechar pela coroa.
 *
 * Seguro fora do Telegram: se `window.Telegram.WebApp.BackButton` não existir
 * (browser comum / dev preview) vira no-op.
 */
export function useTelegramBackButton(opts: {
  onBack?: () => void;
  /** Quando `false`, o hook não mostra o botão (útil enquanto a tela está em loading). */
  show?: boolean;
} = {}): void {
  const navigate = useNavigate();
  const { onBack, show = true } = opts;

  useEffect(() => {
    const btn = tryGetTelegram()?.BackButton;
    if (!btn) return;
    if (!show) {
      btn.hide();
      return;
    }
    const handler = () => {
      if (onBack) onBack();
      else navigate(-1);
    };
    btn.onClick(handler);
    btn.show();
    return () => {
      btn.offClick(handler);
      btn.hide();
    };
  }, [navigate, onBack, show]);
}
